import { Button } from 'antd';
import { ReactNode } from 'react';
import './AppButton.scss';

interface IProps {
  children: ReactNode;
  htmlType?: 'submit';
  className?: string;
  isLoading?: boolean;
  block?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

function AppButton(props: IProps) {
  return (
    <Button
      id="app-button"
      className={`rounded-xl h-12 ${props.className ?? ''}`}
      type="primary"
      block={props.block}
      loading={props.isLoading}
      htmlType={props.htmlType ?? 'button'}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {props.children}
    </Button>
  );
}

export default AppButton;
